module.exports = __webpack_public_path__ + "img/send.448897ed.svg";